module.exports = __webpack_public_path__ + "img/laptop-IV.6998c1ec.png";